import { render, staticRenderFns } from "./FixedAssetsRegister.vue?vue&type=template&id=59102a6d&"
import script from "./FixedAssetsRegister.vue?vue&type=script&lang=js&"
export * from "./FixedAssetsRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports